<template>
  <div class="button-tag__wrapper" v-if="frame" @click="onClick">
    <div class="button-tag" :class="[meta.buttonStyle]" v-bind:style=[outerStyleObj] >
      <div class="button-tag__content" :style="innerStyleObj">
        {{ text }}
      </div>
    </div>
  </div>
</template>
<script>

import { tAligns, evaluateButtonContentStyles } from "./utils"
import { base, titleAndText } from './mixins/multilang'
import { analytics } from './mixins/analytics/'

export default {
  name: "buttonTag",
  mixins: [base, titleAndText, analytics],
  props: ["meta", "frame", "isLastFrame", "dimensions"],
  created() {
    this.$nextTick(() => {
    });
    console.log("buttonTag created", this.meta);
    this.initTag();
  },

  data() {
    return {
      tAlign: 't-left',
      fgColor: 'white',
      // version to kick off update from forceUpdate
      version: 0
    }
  },

  watch: {
    isLastFrame(isLast) {
      console.log(
        "buttonTag isLastFrame %s. current frame %v",
        isLast,
        this.frame
      );
      if (isLast && this.onLastFrame.action !== "none") {
        this.$emit("videoaction", this.onLastFrame);
      }
    }
  },

  computed: {
    outerStyleObj: function() {
      // version to kick off update from forceUpdate
      var v = this.version
      var w = this.frame.pw * this.dimensions.w;
      var h = this.frame.ph * this.dimensions.h;
      var so = {
        width: w + "px",
        height: h + "px",
        "margin-top": -h / 2 + "px",
        "margin-left": -w / 2 + "px",
        "color": this.fgColor,
        "background-color": this.bgColor,
        "border-color": this.borderColor,
        "font-weight": this.fontWeight,
        "border-radius": this.borderRadius + "px"
       
      };
      // omit the property completely if set to 0
      if (this.boxShadow > 0) {
        so['box-shadow'] = `0px 0px ${this.boxShadow}px 0px rgba(0,0,0,0.25)`
      }

      if (this.animation) {
        var a = this.animation
        let av = ''
        if (a.value) {
          av = `${a.animation} ${a.value || 2000}ms ${a.mode}`
        } else {
          av = `${a.animation} ${a.duration || 2}s infinite`
        }

        so['animation'] = av
      }

      return so;
    },
    innerStyleObj: function() {
      // version to kick off update from forceUpdate
      var v = this.version
      let cs = {} // evaluateButtonContentStyles(this.dimensions, this.fontBaseSize)
      cs.textAlign = this.tAlign
      cs.fontSize = `${this.fontBaseSize * this.dimensions.scaleFactorW}pt`
      return cs
    }
  },
  methods: {
    initTag() {
      console.log("buttonTag.inited");
      var meta = this.meta
      this.onLastFrame = meta.onLastFrame || {};
      this.behaviour = meta.behaviour || {};
      this.animation = this.meta.animation;
      this.fgColor = ((meta.colorScheme || {}).colors || [])[1]
      this.bgColor = ((meta.colorScheme || {}).colors || [])[0]
      this.borderColor = ((meta.colorScheme || {}).colors || [])[2]
      this.tAlign = tAligns[meta.textAlignement] || 'left'
      this.fontBaseSize = meta.fontBaseSize || 12
      this.fontWeight = meta.fontWeight || 400
      this.borderRadius = meta.borderRadius || 0
      this.boxShadow = meta.boxShadow || 0
    },
    onClick() {
      console.log("buttonTag clicked", this.meta);
      this.$emit("action", this.meta.behaviour);
      this.trackTag("Button")
    },
    /* forceUpdate is here for the preview Tag in order to kick off an update of the visuals */
    forceUpdate(meta) {
      console.log("forceUpdate", this.version)
      // init meta based props
      this.initTag()
      // inc version that will kick of computed
      this.version = this.version + 1
      this.selectedLanguage = this.meta.text.lang
    }
    
  }
};
</script>
